import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="monitoring--host-import"
export default class extends Controller {
  static targets = ['checkboxValue']

  connect() {
  }

  cleanField() {
    this.checkboxValueTargets.forEach(cb => cb.checked = false)
  }


}
